export const hasUniqueValues = (values: unknown[]) => new Set(values).size === values.length;

export const hasUnique =
  <Key extends string>(key: Key) =>
  (items: Array<Record<Key, unknown>>) =>
    hasUniqueValues(items.map((item) => item[key]));

export const hasSameMembers = (left: string[], right: string[]) => {
  const sortedLeft = [...left].sort();
  const sortedRight = [...right].sort();

  return sortedLeft.length === sortedRight.length && sortedLeft.every((value, index) => value === sortedRight[index]);
};

export const sum = (values: number[]) => values.reduce((total, value) => total + value, 0);

export const sumsTo = (total: number) => (values: Record<string, number>) => sum(Object.values(values)) === total;
